import CustomInputMask from 'designer/component/element/InputMask'
import ControlWrapper from './ControlWrapper'

const InputMaskControl = (props) => {
  return <ControlWrapper {...props} Component={CustomInputMask} />
}

export default InputMaskControl
